<div class="container-fluid g-0 mb-5">
  <div class="row g-0 m-0 d-flex pt-5 pb-5 ps-5 align-items-center">
    <h2 class="title">{{ "ACCOUNT_APPEARANCE_TITLE" | translate }}</h2>
    <h6 class="subtitle">{{ "APPEARANCE_SUBTITLE" | translate }}</h6>
  </div>
  <div class="row g-0 pt-3 justify-content-center">
    <div class="row g-0 justify-content-center">
      <div
        class="col-md-4 mb-3 p-4 item d-flex justify-content-between"
        (click)="
          authService.isAuthorized([PermissionEnum.Personalize_modify])
            ? onRadioChange(Theme.Light)
            : null
        "
      >
        <span class="item-title">{{ "LIGHT_MOOD" | translate }}</span>
        <label class="radio-container" for="light">
          <input
            type="radio"
            name="radio"
            value="light"
            id="light"
            class="radio-input"
            [checked]="selectedTheme === Theme.Light"
          />
          <span class="radio-checkmark"></span>
        </label>
      </div>
    </div>
    <div class="row g-0 justify-content-center">
      <div
        class="col-md-4 mb-3 p-4 item d-flex justify-content-between"
        (click)="
          authService.isAuthorized([PermissionEnum.Personalize_modify])
            ? onRadioChange(Theme.Dark)
            : null
        "
      >
        <span class="item-title">{{ "DARK_MOOD" | translate }}</span>
        <label class="radio-container" for="dark">
          <input
            type="radio"
            name="radio"
            id="dark"
            value="dark"
            class="radio-input"
            [checked]="selectedTheme === Theme.Dark"
          />
          <span class="radio-checkmark"></span>
        </label>
      </div>
    </div>
    <div class="row g-0 justify-content-center">
      <div
        class="col-md-4 p-4 item d-flex justify-content-between"
        (click)="
          authService.isAuthorized([PermissionEnum.Personalize_modify])
            ? onRadioChange(Theme.System)
            : null
        "
      >
        <div>
          <span class="item-title">{{ "SYSTEM_SETTINGS" | translate }}</span>
          <span class="subtitle">{{ "SYSTEM_SETTINGSDESC" | translate }}</span>
        </div>
        <label class="radio-container" for="system">
          <input
            type="radio"
            name="radio"
            id="system"
            value="system"
            class="radio-input"
            [checked]="selectedTheme === Theme.System"
          />
          <span class="radio-checkmark"></span>
        </label>
      </div>
    </div>
  </div>
</div>
